module.exports = __webpack_public_path__ + "static/media/highlight-concierge.341040d8.svg";